module.exports = __webpack_public_path__ + "static/media/network-rapidnet.0230ef24.jpg";